'use client';

import { type Product } from '@shopify/hydrogen-react/storefront-api-types';

import { ProductsContext } from '../contexts/productsContext';

export const ProductsProvider = ({
  children,
  products,
}: {
  children: React.ReactNode;
  products: Product[];
}) => {
  return (
    <ProductsContext.Provider value={{ products }}>
      {children}
    </ProductsContext.Provider>
  );
};
